<template>
  <v-toolbar
    id="core-toolbar"
    :class="{ 'admin-toolbar': isAdmin && user.view === 'admin', 'user-toolbar': user.view === 'user' }"
    flat
    prominent
  >
    <div class="v-toolbar-title" >
      <v-toolbar-title
        class="tertiary--text "
      >
        <v-container
          align-content-center
          fill-height
          grid-list-md
          text-xs-center >
          <v-layout
            row
            wrap>
            <v-flex
              xs1
              sm1
              lg1>
              <v-btn
                v-if="responsive"
                icon
                @click.stop="onClickBtn"
                light
              >
                <v-icon>mdi-view-list</v-icon>
              </v-btn>
            </v-flex>
            <v-flex
              xs8
              sm8
              md9><div class="page-title">{{ title }}</div></v-flex>
            <v-flex
              sm2
              md1 >
              <v-menu
                v-if="user.view === 'admin'"
                offset-y
                attach
                left
                transition="scale-transition"
                origin="center center">
                <template v-slot:activator="{ on }">
                  <v-btn
                    dark
                    icon
                    v-on="on"
                  >
                    <v-badge
                      :overlap="true"
                      title="Notifications">
                      <template v-slot:badge>{{ notifications.total }}</template>
                      <v-icon
                        medium
                        style="color: rgba(0, 0, 0, 0.87)">mdi-email</v-icon>
                    </v-badge>
                  </v-btn>
                </template>

                <v-list class="settings-menu" >
                  <div
                    v-for="module in notifications.modules"
                    :key="module.name">
                    <v-list-tile
                      @click="$router.push(module.link)"
                    >
                      <v-list-tile-action>
                        <v-icon v-text="'mdi-account'"/>
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <v-list-tile-title>{{ module.items }} new {{ module.name }} pending for review</v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </div>
                </v-list>
              </v-menu>
            </v-flex>
            <v-flex
              xs3
              sm2
              md1>
              <v-menu
                offset-y
                attach
                left
                transition="scale-transition"
                origin="center center">
                <template v-slot:activator="{ on }">
                  <v-btn
                    dark
                    icon
                    v-on="on"
                  >
                    <div class="admin-icon">
                      <v-icon style="color: rgba(0, 0, 0, 0.87)">mdi-account</v-icon>
                      <div class="user-fullname">{{ user.name }}</div>
                    </div>
                  </v-btn>
                </template>

                <v-list class="settings-menu">
                  <v-list-tile
                  >
                    <v-list-tile-action>
                      <v-icon v-text="'mdi-account-circle'"/>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title>Profile</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>

                  <!-- <v-list-tile
                  >
                    <v-list-tile-action>
                      <v-icon v-text="'mdi-table'"/>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title>Generate Reports</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile> -->

                  <Can
                    I="switch"
                    a="role">
                    <v-list-tile
                      v-if="user.view === 'admin'"
                      @click="onSyncData">
                      <v-list-tile-action>
                        <v-icon v-text="'refresh'"/>
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <v-list-tile-title>Sync Data <small>(Last sync:{{ $store.state.lastSyncDate }})</small></v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>

                    <v-list-tile
                      v-for="(item, i) in mtools"
                      v-if="user.view === 'admin'"
                      :key="i"
                      @click="$router.push({ path: item.to})">
                      <v-list-tile-action>
                        <v-icon>{{ item.icon }}</v-icon>
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <v-list-tile-title>{{ item.text }}</v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>

                    <!-- <v-list-tile
                      v-if="user.view === 'admin'"
                      @click="$router.push({ path: '/admin/customers'})">
                      <v-list-tile-action>
                        <v-icon v-text="'mdi-account-box-multiple'"/>
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <v-list-tile-title>Customers</v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>

                    <v-list-tile
                      v-if="user.view === 'admin'"
                      @click="$router.push({ path: '/admin/master-payer'})">
                      <v-list-tile-action>
                        <v-icon v-text="'domain'"/>
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <v-list-tile-title>View All Master Payer Account List</v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>

                    <v-list-tile
                      v-if="user.view === 'admin'"
                      @click="$router.push({ path: '/admin/email-audit-trail'})">
                      <v-list-tile-action>
                        <v-icon v-text="'email'"/>
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <v-list-tile-title>View Email Audit Trail</v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile> -->
                    <v-list-tile
                      v-if="viewChangeLogs"
                      @click="showAllAcctInventoryLogs">
                      <v-list-tile-action>
                        <v-icon v-text="'mdi-lead-pencil'"/>
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <v-list-tile-title>View All Account Inventory Change Logs</v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>

                    <v-list-tile
                      v-if="isAdmin"
                      @click="onSwitchView"
                    >
                      <v-list-tile-action>
                        <v-icon v-text="'swap_horiz'"/>
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <v-list-tile-title>Switch view to {{ user.view === 'admin' ? 'Opportunity Registration' : 'Account Inventory' }}</v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </Can>

                  <v-list-tile
                    @click="onLogout"
                  >
                    <v-list-tile-action>
                      <v-icon>power_settings_new</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title>Logout</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </v-flex>
          </v-layout>
        </v-container>
      </v-toolbar-title>
    </div>
    <iframe
      id="receiver"
      :src="oppregUrl"
      width="0"
      height="0"
      style="opacity:0"/>
  </v-toolbar>
</template>

<script>

import { mapState, mapMutations, mapActions } from 'vuex'
import { checkRoutePermission } from '@/utils/helper'

export default {
  props: ['isAdmin', 'user'],
  data: () => ({
    title: null,
    responsive: false,
    responsiveInput: false,
    oppregUrl: process.env.VUE_APP_BASE_OPPREG_URL
  }),
  computed: {
    ...mapState('app', ['admintools']),
    mtools () {
      const mtools = this.admintools.filter(item => checkRoutePermission(item.to))
      return mtools
    },

    pendingOppreg () {
      let pendingStatus = ['Submitted by User', 'Submitted to AWS', 'Incomplete/Under Review']
      return this.$store.state['admin/oppregAdmin'].masterWorkloads.filter(workload => pendingStatus.includes(workload.Workload_Status))
    },
    /**
     * TODO: build notifications by module by getting the number of actionable items per module with the related page/route to work on these
     */
    notifications () {
      let notifsByModule = {
        total: 0,
        modules: []
      }
      if (this.$store.state['admin/oppregAdmin'].masterWorkloads.length) {
        notifsByModule.modules.push({
          name: 'oppreg',
          link: '/admin/oppreg-administration/admin-content',
          items: this.pendingOppreg.length
        })

        notifsByModule.total += this.pendingOppreg.length
      }
      return notifsByModule
    },
    viewChangeLogs () {
      if (this.user.view === 'admin') {
        // console.log('viewChangeLogs', this.user.routes[0].sub_routes['action-menu-list'])
        if (this.user.routes[0].sub_routes['action-menu-list']) {
          return this.user.routes[0].sub_routes['action-menu-list'].includes('change-logs')
        }
      }
    }
  },
  watch: {
    '$route' (val) {
      this.title = val.name
    }
  },
  mounted () {
    this.title = this.$route.name
    this.onResponsiveInverted()
    window.addEventListener('resize', this.onResponsiveInverted)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onResponsiveInverted)
  },

  methods: {
    ...mapMutations('app', ['setDrawer', 'toggleDrawer']),
    ...mapActions({
      onLogout: 'auth/logout'
    }),
    onClickBtn () {
      this.setDrawer(!this.$store.state.app.drawer)
    },
    onResponsiveInverted () {
      // if (window.innerWidth < 991) {
        this.responsive = true
        this.responsiveInput = false
      // } else {
      //   this.responsive = false
      //   this.responsiveInput = true
      // }
    },
    onSwitchView () {
      this.$store.dispatch('switchView')
    },
    onSyncData () {
      this.$store.dispatch('admin/init')
    },
    showAllAcctInventoryLogs () {
      this.$store.dispatch('showAllRecords')
    }
  }
}
</script>

<style lang="scss">

  .v-toolbar {
    z-index: 100;
    margin-bottom: 0px !important;
    border-radius: 0 !important;

    .mdi-view-list {
      font-size: 2rem !important;
    }

    &.user-toolbar {
      background: #666666 !important;
      color:rgba(0, 0, 0, 0.87) !important;
    }

    &.admin-toolbar {
      background: #41B3DF !important;
      color:rgba(0, 0, 0, 0.87) !important;
    }

    .v-toolbar-title{
      position:relative;
      width: 100%;
      font-weight: 600;
    }

    .v-toolbar__title {
      overflow: initial;

      .v-badge {
        top: 5px;
        // right: -20px;
        cursor: pointer;

        .v-badge__badge {
          flex-direction: column;
        }
      }
    }

    .container {
      padding: 0;

      .page-title {
        font-weight:600;
        height: 100%;
        font-size: 1.5em;
        line-height: 53px;
        color: #fff;
      }

      .admin-icon {
        .v-icon {
          font-size: 3em
        }

        .user-fullname {
          font-size: 1em;
          color: #fff;
          margin-top: -27px;
        }
      }
    }
  }

  .settings-menu {
    .v-list__tile__action, .v-list__tile__avatar {
      min-width: 30px !important;
    }
  }

@media all and (max-width:1600px){
  .v-toolbar .container .admin-icon .user-fullname{
    font-size:9px;
  }
}
@media all and (max-width:1245px) and (min-width:999px) {
  .v-toolbar .container .page-title {
    font-size: 20px !important;
  }
}

@media all and (max-width:998px) and (min-width:300px) {
  .v-toolbar .container .page-title {
    font-size: 16px !important;
  }

   .v-toolbar .container .admin-icon .user-fullname{
    font-size:10px;
  }
}

@media all and (max-width:600px) and (min-width:300px) {
  .v-toolbar .container .page-title {
    font-size: 14px !important;
    white-space: normal;
    line-height: 22px;
    padding: 10px 25px;
  }

   .v-toolbar .container .admin-icon .user-fullname{
    font-size:10px;
  }
}

</style>
